export enum CodeEditorType {
  WIDGET = 'widget',
  PAGE = 'page',
  ALL = 'all',
  PROJECT = 'project',
  TEMPLATE = 'template',
  ZONE = 'zone',
  FOOTER_LAYOUT = 'footer-layout',
  MOCK_DATA = 'mock-data',
}
